import { EventIdentifier } from '@capsicum/common';
import { type SellEntrypoint } from '@capsicum/socios-core';
import { BuySellButtons } from '@capsicum/socios-core-web';
import { useSendAnalyticsEventFromGateway } from '@capsicum/socios-gateway/hooks';
import { styled } from 'styled-components';

import { SectionWrapper } from '../WalletPartnerDetails.styled';

export type BuySellButtonsSectionType = {
	entrypoint: SellEntrypoint;
	fanTokenCurrencyId: string;
	partnerId?: string;
};

export const BuySellButtonsSection = ({ entrypoint, fanTokenCurrencyId, partnerId }: BuySellButtonsSectionType) => {
	const { sendPFFTAnalyticsEvent } = useSendAnalyticsEventFromGateway();

	return (
		<S.ButtonsWrapper>
			<BuySellButtons
				entrypoint={entrypoint}
				fanTokenCurrencyId={fanTokenCurrencyId}
				partnerId={partnerId}
				testID="partnerPage-marketplace"
				onClickBuyEvent={() =>
					sendPFFTAnalyticsEvent(EventIdentifier.GatewayEventBuyButtonClicked, {
						partner_name: 'partner.name'
					})
				}
			/>
		</S.ButtonsWrapper>
	);
};

namespace S {
	export const ButtonsWrapper = styled(SectionWrapper)`
		align-items: center;
		align-self: flex-end;
		flex-shrink: 0;

		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			position: fixed;
			bottom: 0;
			left: 0;
			/* 3 due to the digital collectible staked grey bg has 2 */
			z-index: 3;

			background: ${({ theme }) => theme.colors.backgrounds.main.container};
		}
	`;
}
